import { memo } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
import { convertDistance, DistanceUnit } from '../../../constants';

const DistanceFromLocationLabel = ({
  distance,
  label,
  headingLabel,
  parentClassName,
  walkingDistance,
  labelClassName,
  valueClassName,
}) => {
  const { travelAgency } = useSelector((state) => state.user);
  const distanceUnit =
    travelAgency?.settings?.hotelSearchRadiusUnit === 'KM'
      ? DistanceUnit.KILOMETERS
      : DistanceUnit.MILES;

  const displayUnit = distanceUnit === DistanceUnit.KILOMETERS ? 'km' : 'miles';

  const doHaveDriveDistance = distance !== null && distance !== undefined;
  const doHaveWalkDistance = walkingDistance !== null && walkingDistance !== undefined;
  if ((!doHaveDriveDistance && !doHaveWalkDistance) || !label) return '';

  return (
    <>
      {headingLabel && distance ? (
        <div className={labelClassName || parentClassName}>{headingLabel}</div>
      ) : (
        <div />
      )}
      <div className={valueClassName || parentClassName}>
        {doHaveDriveDistance && distance >= 0 ? (
          <>
            <NumberFormat
              value={convertDistance(distance, distanceUnit)}
              displayType="text"
              decimalScale={2}
            />
          </>
        ) : (
          <></>
        )}
        {doHaveWalkDistance && walkingDistance >= 0 ? (
          <>
            {doHaveDriveDistance && distance >= 0 && <> {displayUnit} /</>}
            <NumberFormat
              value={convertDistance(walkingDistance, distanceUnit)}
              displayType="text"
              className="ml-2"
              decimalScale={2}
            />
          </>
        ) : (
          <></>
        )}{' '}
        {displayUnit} from {label}
      </div>
    </>
  );
};
DistanceFromLocationLabel.propTypes = {
  distance: PropTypes.number,
  walkingDistance: PropTypes.number,
  label: PropTypes.string,
  headingLabel: PropTypes.string,
  parentClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
};

DistanceFromLocationLabel.defaultProps = {
  distance: null,
  walkingDistance: null,
  label: null,
  headingLabel: null,
  parentClassName: '',
  labelClassName: '',
  valueClassName: '',
};

export default memo(DistanceFromLocationLabel);
